<ng-template #tooltipTemplate><div [innerHtml]="tooltipData"></div></ng-template>

<span
  [ngClass]="tooltipClass ? tooltipClass : ''"
  contentType="template"
  tooltipClass="tooltip-container"
  placement="right"
  maxWidth="500px"
  [tooltip]="tooltipTemplate">
  <i class="cursor icon {{ iconSize }} {{ tooltipIcon }} {{ iconColor }}"></i>
</span>
<!--END INFORMATION TOOLTIP-->
